exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".from[data-v-69834798]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:20px;border-bottom:1px solid #eeeeee}.card-box[data-v-69834798]{min-height:calc(100vh - 65px)}\n", ""]);

// exports
